module.exports = __webpack_public_path__ + "static/media/turtrello.238e8465.JPG";